export interface CreditTransfer {
  messageIdentification: string;
  numberOfTransactions: number;
  controlSum: number;
  skippedPayrollsDueToMissingBankData: number;
  debitorName: string;
  debitorIBAN: string;
  collectionDate: string;
  transactions: CreditTransferTransaction[];
}

export interface CreditTransferTransaction {
  endToEndIdentification: string;
  amount: number;
  creditorName: string;
  creditorIBAN: string;
  remittanceInformation: string;
}

function parseCreditTransferTransaction(
  data?: Partial<CreditTransferTransaction>
): CreditTransferTransaction {
  return {
    endToEndIdentification: data?.endToEndIdentification || '',
    amount: data?.amount || 0,
    creditorName: data?.creditorName || '',
    creditorIBAN: data?.creditorIBAN || '',
    remittanceInformation: data?.remittanceInformation || '',
  };
}

function parse(data?: Partial<CreditTransfer>): CreditTransfer {
  return {
    messageIdentification: data?.messageIdentification || '',
    numberOfTransactions: data?.numberOfTransactions || 0,
    controlSum: data?.controlSum || 0,
    skippedPayrollsDueToMissingBankData:
      data?.skippedPayrollsDueToMissingBankData || 0,
    debitorName: data?.debitorName || '',
    debitorIBAN: data?.debitorIBAN || '',
    collectionDate: data?.collectionDate || '',
    transactions: (data?.transactions || []).map(
      parseCreditTransferTransaction
    ),
  };
}

function transactionToAPI(transaction: CreditTransferTransaction) {
  return {
    EndToEndIdentification: transaction.endToEndIdentification,
    Amount: transaction.amount,
    CreditorName: transaction.creditorName,
    CreditorIBAN: transaction.creditorIBAN,
    RemittanceInformation: transaction.remittanceInformation,
  };
}

function toAPI(data: CreditTransfer): any {
  return {
    MessageIdentification: data.messageIdentification,
    NumberOfTransactions: data.numberOfTransactions,
    ControlSum: data.controlSum,
    SkippedPayrollsDueToMissingBankData:
      data.skippedPayrollsDueToMissingBankData,
    DebitorName: data.debitorName,
    DebitorIBAN: data.debitorIBAN,
    CollectionDate: data.collectionDate,
    Transactions: data.transactions.map(transactionToAPI),
  };
}

export default {
  parse,
  toAPI,
};
